export default __webpack_public_path__ + "static/media/mas-runner-2.3a7e39af.png";